import { ROLES } from "../routes/role.constants";

export const sidebarMenu = [
  {
    items: [
      {
        label: "Reconocer tus 7 Fortalezas",
        to: "/",
        icon: "material-symbols:person-search",
        roles: [
          ROLES.ADMIN_SYS,
          ROLES.ADMIN_ESCOLAR,
          ROLES.MENTOR,
          ROLES.ESTUDIANTE,
        ],
      },
      {
        label: "Mis fortalezas",
        to: "/mis-fortalezas",
        icon: "material-symbols:stars",
        roles: [
          ROLES.ADMIN_SYS,
          ROLES.ADMIN_ESCOLAR,
          ROLES.MENTOR,
          ROLES.ESTUDIANTE,
        ],
      },
      {
        label: "Agenda",
        to: "/agenda",
        icon: "solar:calendar-bold-duotone",
        roles: [
          ROLES.ADMIN_SYS,
          ROLES.ADMIN_ESCOLAR,
          ROLES.MENTOR,
          ROLES.ESTUDIANTE,
        ],
      },
      {
        label: "Mis Actividades",
        to: "/mis-actividades",
        icon: "mdi:clipboard-text-outline",
        roles: [
          ROLES.ADMIN_SYS,
          ROLES.ADMIN_ESCOLAR,
          ROLES.MENTOR,
          ROLES.ESTUDIANTE,
        ],
      },
      //{
      //  label: "Conversación",
      //  to: "/conversacion",
      //  icon: "mdi:forum",
      //  roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.MENTOR, ROLES.ESTUDIANTE],
      //},
      {
        label: "Dashboard",
        to: "/dashboard",
        icon: "stash:dashboard",
        roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
      },
      {
        label: "Usuarios",
        to: "/usuarios",
        icon: "fa6-solid:users",
        roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.MENTOR],
      },
      {
        label: "Escuelas",
        to: "/escuelas",
        icon: "icon-park-outline:school",
        roles: [ROLES.ADMIN_SYS, ROLES.MENTOR],
      },
      {
        label: "Planteles",
        to: "/planteles",
        icon: "fa7-solid:school",
        roles: [ROLES.ADMIN_SYS],
      },
      {
        label: "Configuración de talentos",
        icon: "mdi:cog-outline",
        roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
        submenu: [
          {
            label: "Talentos",
            to: "/talentos",
            icon: "mdi:star-outline",
          },
          {
            label: "Frases",
            to: "/frases",
            icon: "mdi:format-quote-close",
          },
          {
            label: "Frases de respuesta",
            to: "/frases-respuesta",
            icon: "mdi:message-reply-text-outline",
          },
          {
            label: "Configuración de algoritmo",
            to: "/configurar-algoritmo",
            icon: "hugeicons:algorithm",
          },
          {
            label: "Configuración adicional",
            to: "/configuracion-global-talentos",
            icon: "mdi:earth",
          },
        ],
      },
      // Módulo "Configuración de fortalezas" (global) oculto a petición del cliente.
      // Reemplazado por "Fortalezas 2.0". Rutas /configuracion-fortalezas/* siguen activas.
      // {
      //   label: "Configuración de fortalezas",
      //   icon: "mdi:shield-star-outline",
      //   roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
      //   submenu: [
      //     { label: "Áreas", to: "/configuracion-fortalezas/areas", icon: "mdi:shape-outline" },
      //     { label: "Acciones", to: "/configuracion-fortalezas/acciones", icon: "mdi:lightbulb-outline" },
      //     { label: "Configuración adicional", to: "/fortaleza-config-adicional", icon: "mdi:play-circle-outline" },
      //   ],
      // },
      {
        label: "Confirmación de talentos",
        icon: "mdi:brain",
        roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
        submenu: [
          {
            label: "Preguntas",
            to: "/preguntas-confirmacion",
            icon: "mdi:help-circle-outline",
          },
          {
            label: "Frases",
            to: "/frases-confirmacion",
            icon: "mdi:message-text-outline",
          },
          {
            label: "Configuración adicional",
            to: "/confirmacion-config-adicional",
            icon: "mdi:play-circle-outline",
          },
        ],
      },
      {
        label: "Fortalezas 2.0",
        icon: "mdi:comment-question-outline",
        roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
        submenu: [
          {
            label: "Fortaleza",
            to: "/preguntas-talento/frases",
            icon: "mdi:message-text-outline",
          },
          {
            label: "Afirmaciones",
            to: "/preguntas-talento/sub-frases",
            icon: "mdi:format-list-bulleted-type",
          },
          {
            label: "Opciones Sí / No",
            to: "/preguntas-talento/opciones",
            icon: "mdi:toggle-switch-outline",
          },
          {
            label: "Configuración adicional",
            to: "/preguntas-talento/configuracion-adicional",
            icon: "mdi:play-circle-outline",
          },
        ],
      },
      // Módulo "Aplicación de talentos" oculto a petición del cliente.
      // Las rutas /actividades-aplicacion, /frases-aplicacion y
      // /aplicacion-config-adicional siguen activas en caso de necesitarlas.
      // {
      //   label: "Aplicación de talentos",
      //   icon: "streamline-ultimate:human-resources-workflow",
      //   roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
      //   submenu: [
      //     { label: "Actividades", to: "/actividades-aplicacion", icon: "material-symbols:add-notes-outline-sharp" },
      //     { label: "Frases", to: "/frases-aplicacion", icon: "mdi:message-text-outline" },
      //     { label: "Configuración adicional", to: "/aplicacion-config-adicional", icon: "mdi:play-circle-outline" },
      //   ],
      // },
      {
        label: "Conversaciones",
        icon: "mdi:forum-outline",
        roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
        submenu: [
          {
            label: "Conversaciones",
            to: "/conversaciones-globales",
            icon: "mdi:forum-outline",
          },
          {
            label: "Contenido",
            to: "/conversaciones",
            icon: "mdi:message-text-outline",
          },
        ],
      },
      {
        label: "Seguimiento Mentores",
        to: "/seguimiento-mentores",
        icon: "mdi:account-group-outline",
        roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
      },
      {
        label: "Mis alumnos",
        to: "/mis-alumnos",
        icon: "mdi:account-school-outline",
        roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR, ROLES.MENTOR],
      },
      {
        label: "Información adicional",
        to: "/cuestionarios",
        icon: "mdi:clipboard-text-outline",
        roles: [ROLES.ADMIN_SYS, ROLES.ADMIN_ESCOLAR],
      },
      // {
      //   label: "Roles y Permisos",
      //   to: "/roles-permisos",
      //   icon: "mdi:shield-key-outline",
      //   roles: [ROLES.ADMIN_SYS],
      // },
    ],
  },
];
